/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { CategoryData } from '../data';
import { CategoryCard } from './CategoryCard';

interface Props {
    data: CategoryData[];
}

export const CategoryList = ({ data }: Props) => {
    return (
        <div
            css={css`
                margin: 30px;
            `}
        >
            <Grid container spacing={2}>
                {data.map((category) => (
                    <Grid key={category.categoryId} item xs={6} sm={4}>
                        <CategoryCard data={category} />
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};
